
/* =========================================================
   ADHÉSIF-VITRAIL — VISUALISEUR 2
   Positionnement responsive des fiches produits classiques

   Ordinateur : sous la galerie, colonne gauche
   Mobile : après les boutons d'achat

   Une seule instance du visualiseur.
   Aucun impact sur le configurateur personnalisé.
   ========================================================= */

(() => {
  "use strict";

  const MOBILE_BREAKPOINT = 750;

  function initialiserPlacement() {
    const section = document.querySelector(
      'product-info[id^="MainProduct-"]'
    );

    if (!section) return;

    const emplacementDesktop = section.querySelector(
      ".av-modele-sous-galerie"
    );

    const emplacementMobile = section.querySelector(
      "#av-modele-emplacement-mobile"
    );

    if (!emplacementDesktop || !emplacementMobile) return;

    // Recherche du Visualiseur 2 dans ses deux emplacements possibles.
    const visualiseur =
      emplacementDesktop.querySelector("#av-configurateur-shopify") ||
      emplacementMobile.querySelector("#av-configurateur-shopify");

    if (!visualiseur) return;

    // Repère permanent dans l'emplacement ordinateur.
    const repereDesktop = document.createComment(
      "Emplacement ordinateur du Visualiseur 2"
    );

    emplacementDesktop.appendChild(repereDesktop);

    function positionnerVisualiseur() {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;

      if (mobile) {
        if (visualiseur.parentElement !== emplacementMobile) {
          emplacementMobile.appendChild(visualiseur);
        }
      } else {
        if (visualiseur.parentElement !== emplacementDesktop) {
          repereDesktop.after(visualiseur);
        }
      }
    }

    positionnerVisualiseur();

    window.addEventListener("resize", positionnerVisualiseur);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiserPlacement,
      { once: true }
    );
  } else {
    initialiserPlacement();
  }
})();
